const toolOptions = [
    ['bold', 'italic', 'underline', 'strike'],          //B  I  U  S
    ['blockquote', 'code-block', 'code'],               //引用(”) + code-block + code(内联)
    [{'header':1},{'header':2}],                        //h1  h2
    [{ 'list': 'ordered'}, { 'list': 'bullet' }],       //列表样式 数字或点
    [{ 'script': 'sub'}, { 'script': 'super' }],        //上标 下标
    [{ 'indent': '-1'}, { 'indent': '+1' }],            //首行缩进
    [{ 'direction': 'rtl' }],                           //文字起始方向
    [{ 'align': [] }],                                  //文字位置
    [{ 'size': ['small', false, 'large', 'huge'] }],    //字体大小
    [{ 'header': [1, 2, 3, 4, 5, 6, false] }],          //h1~h6
    [
        {'color': [ '#000000', '#e60000', '#ff9900', '#ffff00', '#008a00', '#0066cc', '#9933ff', 
                    '#ffffff', '#facccc', '#ffebcc', '#ffffcc', '#cce8cc', '#cce0f5', '#ebd6ff', 
                    '#bbbbbb', '#f06666', '#ffc266', '#ffff66', '#66b966', '#66a3e0', '#c285ff', 
                    '#888888', '#a10000', '#b26b00', '#b2b200', '#006100', '#0047b2', '#6b24b2',
                    '#444444', '#5c0000', '#663d00', '#666600', '#003700', '#002966', '#3d1466' ] }, //字体颜色 
        { 'background': ['#000000', '#e60000', '#ff9900', '#ffff00', '#008a00', '#0066cc', '#9933ff', 
                    '#ffffff', '#facccc', '#ffebcc', '#ffffcc', '#cce8cc', '#cce0f5', '#ebd6ff', 
                    '#bbbbbb', '#f06666', '#ffc266', '#ffff66', '#66b966', '#66a3e0', '#c285ff', 
                    '#888888', '#a10000', '#b26b00', '#b2b200', '#006100', '#0047b2', '#6b24b2',
                    '#444444', '#5c0000', '#663d00', '#666600', '#003700', '#002966', '#3d1466' ] } //背景色
    ],
    [{ 'font': ['', 'serif', 'monospace'] }],          //字体大小
    ['formula'],
    ['link', 'image', 'video'],
    ['clean'],
    ['sourceEditor']
]

const uploadConfig = {
    action:  '',  // 必填参数 图片上传地址
    methods: 'POST',  // 必填参数 图片上传方式
    token: '',  // 可选参数 如果需要token验证，假设你的token有存放在sessionStorage
    name: 'img',  // 必填参数 文件的参数名
    size: 500,  // 可选参数   图片大小，单位为Kb, 1M = 1024Kb
    accept: 'image/png, image/gif, image/jpeg, image/bmp, image/x-icon'  // 可选 可上传的图片格式
};

const handlers = {
    sourceEditor: function(){     //添加工具方法
        function insertHtmlAtCaret(html) {
            var sel, range;
            if (window.getSelection) {
                // IE9 and non-IE
                sel = window.getSelection();
                if (sel.getRangeAt && sel.rangeCount) {
                    range = sel.getRangeAt(0);
                    range.deleteContents();
                    // Range.createContextualFragment() would be useful here but is
                    // non-standard and not supported in all browsers (IE9, for one)
                    var el = document.createElement("div");
                    el.innerHTML = html;
                    var frag = document.createDocumentFragment(), node, lastNode;
                    while ((node = el.firstChild)) {
                        lastNode = frag.appendChild(node);
                    }
                    range.insertNode(frag);
                    // Preserve the selection
                    if (lastNode) {
                        range = range.cloneRange();
                        range.setStartAfter(lastNode);
                        range.collapse(true);
                        sel.removeAllRanges();
                        sel.addRange(range);
                    }
                }
            } else if (document.selection && document.selection.type != "Control") {
                // IE < 9
                document.selection.createRange().pasteHTML(html);
            }
        }
        insertHtmlAtCaret("<b><img src='https://images.pexels.com/photos/2020941/pexels-photo-2020941.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500'></b>");
        // insertHtmlAtCaret("<span style='padding:0 50px;'>111</span>");
        //var range = document.getSelection().getRangeAt(0)
        // range.getBoundingClientRect("<span>123</span>") 
        //var range = window.getSelection().getRangeAt(0)
        /*var strongNode = document.createElement('strong')
        // 选中区域文本
        strongNode.innerHTML = range.toString()
        // 删除选中区
        range.deleteContents()*/
        // 在光标处插入新节点
        //range.insertNode("123")
        // var el_p = this.quill.container;
        // var el = el_p.children
        // for(var i = 0; i < el.length; i++){
        //     if(el[i].className.includes('ql-editor')){
        //         el[i].children[el[i].children.length - 1].innerHTML += '123'
        //     }
        // }
        // alert('我新添加的工具方法');
    },
    image: function image() {
        var self = this;
 
        var fileInput = this.container.querySelector('input.ql-image[type=file]');
        if (fileInput === null) {
            fileInput = document.createElement('input');
            fileInput.setAttribute('type', 'file');
            // 设置图片参数名
            if (uploadConfig.name) {
                fileInput.setAttribute('name', uploadConfig.name);
            }
            // 可设置上传图片的格式
            fileInput.setAttribute('accept', uploadConfig.accept);
            fileInput.classList.add('ql-image');
            // 监听选择文件
            fileInput.addEventListener('change', function () {
                // 创建formData
                var formData = new FormData();
                formData.append(uploadConfig.name, fileInput.files[0]);
                formData.append('object','product');
                // 如果需要token且存在token
                if (uploadConfig.token) {
                    formData.append('token', uploadConfig.token)
                }
                // 图片上传
                var xhr = new XMLHttpRequest();
                xhr.open(uploadConfig.methods, uploadConfig.action, true);
                // 上传数据成功，会触发
                xhr.onload = function (e) {
                    if (xhr.status === 200) {
                        var res = JSON.parse(xhr.responseText);
                        let length = self.quill.getSelection(true).index;
                        //这里很重要，你图片上传成功后，img的src需要在这里添加，res.path就是你服务器返回的图片链接。            
                        self.quill.insertEmbed(length, 'image', res.path);
                        self.quill.setSelection(length + 1)
                    }
                    fileInput.value = ''
                };
                // 开始上传数据
                xhr.upload.onloadstart = function (e) {
                    fileInput.value = ''
                };
                // 当发生网络异常的时候会触发，如果上传数据的过程还未结束
                xhr.upload.onerror = function (e) {
                };
                // 上传数据完成（成功或者失败）时会触发
                xhr.upload.onloadend = function (e) {
                    // console.log('上传结束')
                };
                xhr.send(formData)
            });
            this.container.appendChild(fileInput);
        }
        fileInput.click();
    }
};
 
export default {
    placeholder: '请输入...',
    theme: 'snow',  // 主题
    modules: {
        toolbar: {
            container: toolOptions,  // 工具栏选项
            handlers: handlers  // 事件重写
        }
    },
    initButton:function(){      //在使用的页面中初始化按钮样式
        const sourceEditorButton = document.querySelector('.ql-sourceEditor');
        sourceEditorButton.innerHTML = "<i class='el-icon-edit-outline' style='width:100%;height:100%;font-size:14px;text-align:center;line-height:18px;'></i>";
    }
};


// WEBPACK FOOTER //
// ./src/assets/js-plug-in-unit/vue-quill-editor-config.js